/**
 * 数値フォーマッター用ユーティリティ関数
 */

// 定数
const PERCENTAGE_DECIMAL_PLACES = 1
const DEFAULT_VALUE = '0'

/**
 * パーセンテージ値を安全にフォーマット
 * @param value 数値、null、またはundefined
 * @param decimalPlaces 小数点以下の桁数（デフォルト: 1）
 * @returns フォーマットされた文字列
 */
export const formatPercentage = (
  value: number | null | undefined,
  decimalPlaces = PERCENTAGE_DECIMAL_PLACES
): string => {
  // null/undefinedチェック
  if (value == null) return DEFAULT_VALUE

  // 数値の妥当性チェック（NaN、Infinityなど）
  if (!Number.isFinite(value)) return DEFAULT_VALUE

  // 負の値の場合も考慮
  if (value < 0) return DEFAULT_VALUE

  return value.toFixed(decimalPlaces)
}
